
import React from 'react'
import ReceiptInfo from './ReceiptInfo'
import ReceiptTable from './ReceiptTable'
import getProp from '@f/get-prop'

const ReceiptPayment = props => (
  <div>
    <ReceiptInfo
      coupon={getProp('subscription.coupon.id', props.billing)}
      extra={props.billing && props.billing.extraInfo}
      workspaceSlug={props.workspaceSlug}
      {...props.payment} />
    <ReceiptTable {...props.payment} />
  </div>
)

export default ReceiptPayment



// WEBPACK FOOTER //
// ./components/ReceiptPayment.js